import type { AuthoredEntityOrSingleSchema } from '@cli-types/core-engine/add-field.js'
import type { SchemaField } from '@cli-types/core-engine/schema.js'
import {
  ADD_FIELD_CONFIRM_INITIAL_VALUE,
  CREATE_PROMPT_CONTEXT
} from '@cli-constants/prompt-copy.js'
import { promptConfirm } from '../schema-prompts/prompt-confirm.js'
import { promptSchemaSlotField } from './prompt-schema-slot-field.js'

export async function promptSchemaSlotFields(
  kind: 'entity' | 'single',
  schemasDir: string,
  titleField: SchemaField
): Promise<AuthoredEntityOrSingleSchema['slot']> {
  const mainFields: SchemaField[] = [titleField]
  const sidebarFields: SchemaField[] = []

  while (
    await promptConfirm(
      CREATE_PROMPT_CONTEXT,
      'Add another field?',
      ADD_FIELD_CONFIRM_INITIAL_VALUE
    )
  ) {
    await promptSchemaSlotField(kind, schemasDir, mainFields, sidebarFields)
  }

  return {
    main: { fields: mainFields },
    ...(sidebarFields.length > 0 ? { sidebar: { fields: sidebarFields } } : {})
  }
}
